module.exports = "https://bin.bnbstatic.com/_next/static/images/mac-home-3511664450a5d3afdc0427b9a167ad8a.png";